/** @deprecated legacy mini-profile; cleared on logout */
const PROFILE_KEY = 'partner_profile';

export const APPLICATION_SNAPSHOT_KEY = 'partner_application_snapshot';

function defaultHours() {
  const day = (open, fullDay, start, end) => ({ open, fullDay, start, end });
  return {
    monday: day(false, true, '09:00', '17:00'),
    tuesday: day(true, false, '09:00', '17:00'),
    wednesday: day(false, true, '09:00', '17:00'),
    thursday: day(false, true, '09:00', '17:00'),
    friday: day(true, false, '09:00', '17:00'),
    saturday: day(false, true, '09:00', '17:00'),
    sunday: day(true, false, '09:00', '17:00'),
  };
}

/** Same shape as ApplySalonJoinPage `form` */
export function createEmptyPartnerApplicationForm(joinType) {
  const jt = String(joinType || '').toLowerCase();
  return {
    joinType: jt === 'groomer' ? 'groomer' : 'salon',
    countrySlug: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    mailingAddress: '',
    yearsExperience: '',
    legalSalonName: '',
    physicalAddress: '',
    taxId: '',
    groomingStations: '',
    bathingTubs: '',
    groomersCount: '',
    hasInsurance: '',
    hours: defaultHours(),
    serviceOffered: [],
    serviceOtherText: '',
    websiteUrl: '',
    facebook: '',
    tiktok: '',
    referral: '',
    primaryServiceType: '',
    petsGroomed: '',
    petsServiced: [],
    hasCertifications: '',
    certifications: '',
    hasDriversLicense: '',
    preferredServiceType: [],
    hasTools: '',
    hasTaxId: '',
    workCurrently: '',
    hasReferences: '',
    groomerInstagram: '',
    groomerFacebook: '',
    groomerTiktok1: '',
    groomerTiktok2: '',
    groomerLearnGrooming: '',
  };
}

function mergeHours(base, saved) {
  const out = {};
  const keys = Object.keys(base || {});
  keys.forEach((k) => {
    out[k] = { ...(base[k] || {}), ...(saved?.[k] || {}) };
  });
  return out;
}

export function mergePartnerApplicationSnapshot(saved, joinType) {
  const jt = String(joinType || saved?.joinType || 'salon').toLowerCase();
  const base = createEmptyPartnerApplicationForm(jt);
  if (!saved || typeof saved !== 'object') return base;
  const out = { ...base, ...saved, joinType: jt };
  out.hours = mergeHours(base.hours, saved.hours);
  out.serviceOffered = Array.isArray(saved.serviceOffered) ? [...saved.serviceOffered] : [...base.serviceOffered];
  out.petsServiced = Array.isArray(saved.petsServiced) ? [...saved.petsServiced] : [...base.petsServiced];
  out.preferredServiceType = Array.isArray(saved.preferredServiceType)
    ? [...saved.preferredServiceType]
    : [...base.preferredServiceType];
  return out;
}

export function readPartnerAuth() {
  try {
    const raw = localStorage.getItem('partner_auth');
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && typeof v === 'object' ? v : null;
  } catch {
    return null;
  }
}

export function readPartnerApplicationSnapshot() {
  try {
    const raw = localStorage.getItem(APPLICATION_SNAPSHOT_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && typeof v === 'object' ? v : null;
  } catch {
    return null;
  }
}

export function writePartnerApplicationSnapshot(formLike) {
  const jt = String(formLike?.joinType || '').toLowerCase();
  const merged = mergePartnerApplicationSnapshot(formLike, jt);
  localStorage.setItem(APPLICATION_SNAPSHOT_KEY, JSON.stringify(merged));
}

export function clearPartnerSession() {
  try {
    localStorage.removeItem('partner_auth');
    localStorage.removeItem(PROFILE_KEY);
    localStorage.removeItem(APPLICATION_SNAPSHOT_KEY);
  } catch {
    // ignore
  }
}
